import { getEnv } from '@/composables/helpers/getEnv'
import { fetchOneEntry, isPreviewing, getBuilderSearchParams } from '@builder.io/sdk-vue'
import { useGlobalStore } from '@/stores/global'
import { getModelFromURL } from '@/composables/builder/model'

export const getBuilderContent = async (updates) => {
    const { $config } = useNuxtApp()
    const apiKey = getEnv('builderApi')
    const route = useRoute()
    let builderEnv = getEnv('builderEnv')
    const dataEnv = getEnv('dataEnv')
    const globalStore = useGlobalStore()
    const { urlExceptions } = useGlobalStore() || {}
    const model_options = getModelFromURL(route.path, 'page', $config, urlExceptions)
    const model = model_options.model ? model_options.model : 'page'
    const options = model_options.options || {}
    const now = useState('now', () => { return new Date().getTime() })

    let path = model_options.url
    if (path.length > 1) path = path.replace(/\/$/, '')
    if (typeof path === 'string') path = path.toLowerCase()

    // Local pages are full resolved by Nuxt, although URL Exceptions can override.
    if ( options.local === true && model === 'nuxt' ) {
        return {
            content: false,
            pending: false,
            can_show_content: false,
            error: false,
            model: false,
            api_key: apiKey,
            options: options
        }
    }

    const params = {
        model,
        apiKey,
        userAttributes: { urlPath: path },
        options: { enrich: false, ...getBuilderSearchParams(route.query), includeUnpublished: isPreviewing(route.fullPath) },
        now
    }

    if (!isPreviewing(route.fullPath)) {
        if (model_options.model === 'blog') builderEnv = dataEnv
        params['query'] = {
            data: {
                environment: { $eq: builderEnv }
            }
        }
    }

    const url_key = btoa(path)

    let can_show_content = false
    let error = false

    try {
        const { data: content, pending } = await useAsyncData(`page:${url_key}`, () => fetchOneEntry(params))
        can_show_content = content.value ? true : isPreviewing(route.fullPath)
        // We need a block index on all items
        if (content?.value) {
            if (content.value.data && content.value.data.blocks && Array.isArray(content.value.data.blocks)) {
                content.value.data.blocks.forEach((block, index) => {
                    if (content.value.data.blocks[index].component?.options) {
                        content.value.data.blocks[index].component.options.blockIndex = index
                    }
                })
            }
            globalStore.pageContent = content.value
            globalStore.pageModel = model
        }

        if (!can_show_content && !isPreviewing(route.fullPath)) {
            error = createError({
                statusCode: 404,
                statusMessage: `Page Not Found in ${builderEnv}`,
                fatal: true,
                params: JSON.stringify(params)
            })
        }

        return {
            content: content,
            pending: pending,
            can_show_content: can_show_content,
            api_key: apiKey,
            error: error,
            model: model,
            options: options
        }

    } catch(error) {

        error = createError({
            statusCode: 500,
            statusMessage: 'Server Error',
            fatal: true,
            params: params
        })

        return {
            content: false,
            pending: false,
            can_show_content: false,
            api_key: apiKey,
            error: error,
            model: model,
            options: options
        }
    }
}
